import Page from 'flarum/common/components/Page';
import SiteSidebar from './SiteSidebar';
import { icon } from './ui';
import { portalHome } from './portalApi';
class InfoBase extends Page {
  data = null;
  oninit(v) {
    super.oninit(v);
    portalHome().then(d => {
      this.data = d;
      m.redraw();
    }).catch(() => null);
  }
  shell(title, eyebrow, body) {
    return m("div", {
      className: "NtPortalPage"
    }, m("div", {
      className: "container NtSubpageLayout"
    }, m(SiteSidebar, null), m("main", null, m("header", {
      className: "NtPageHeading"
    }, m("small", null, eyebrow), m("h1", null, title)), body)));
  }
}
export class ContactPage extends InfoBase {
  oncreate() {
    document.title = 'Kontakt - NovaTruck & RP';
    window.scrollTo(0, 0);
  }
  view() {
    const s = this.data?.settings || {};
    return this.shell('Kontakt', 'NOVATRUCK • KONTAKT', m("div", {
      className: "NtInfoCards"
    }, m("article", null, icon('fas fa-envelope'), m("h2", null, "E-mail"), m("p", null, s['contact.email'] || 'Uzupełnij adres w Nova Control Center → Ustawienia.')), m("article", null, icon('fab fa-discord'), m("h2", null, "Discord"), m("p", null, s['contact.discord'] || 'Dodaj adres Discord w Nova Control Center.')), m("article", null, icon('fas fa-life-ring'), m("h2", null, "Pomoc"), m("p", null, s['contact.support_text'] || 'W sprawach konta, serwera i forum skorzystaj z działu Pomoc techniczna.'))));
  }
}
export class PrivacyPage extends InfoBase {
  oncreate() {
    document.title = 'Polityka prywatności - NovaTruck & RP';
    window.scrollTo(0, 0);
  }
  view() {
    const s = this.data?.settings || {};
    return this.shell('Polityka prywatności', 'NOVATRUCK • PRYWATNOŚĆ', m("section", {
      className: "NtLegalPage"
    }, m("p", null, s['privacy.page_intro'] || 'NovaTruck & RP przetwarza dane niezbędne do działania konta NovaID, forum, integracji MTA i funkcji społecznościowych.'), m("h2", null, "Zakres danych"), m("p", null, "Konto, identyfikatory integracji, dane techniczne wymagane dla bezpiecze\u0144stwa oraz dane dobrowolnie podane przez u\u017Cytkownika."), m("h2", null, "Kontakt w sprawach prywatno\u015Bci"), m("p", null, s['contact.email'] || 'Adres kontaktowy administratora należy ustawić w Nova Control Center.')));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/InfoPages', { ContactPage: ContactPage,PrivacyPage: PrivacyPage, });